import { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Box, Text, Stack } from '@mantine/core';
import { IconGitBranch } from '@tabler/icons-react';

function BranchNode({ data, selected }: NodeProps) {
  const branches = data.branches || [];
  const nodeWidth = 180;
  
  // Calculate handle positions evenly across the bottom
  const getHandlePosition = (index: number, total: number) => {
    if (total === 1) return 50;
    return ((index + 1) / (total + 1)) * 100;
  };

  return (
    <Box
      style={{
        background: '#fef3c7',
        border: `2px solid ${selected ? '#f59e0b' : '#fbbf24'}`,
        borderRadius: '8px',
        padding: '12px 16px',
        minWidth: `${nodeWidth}px`,
        boxShadow: selected ? '0 4px 12px rgba(245, 158, 11, 0.3)' : '0 2px 8px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Handle type="target" position={Position.Top} />
      
      <Stack gap={6} align="center">
        <Box style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <IconGitBranch size={18} color="#f59e0b" />
          <Text size="xs" fw={700} c="#92400e">
            BRANCH
          </Text>
        </Box>
        
        {data.title && (
          <Text size="xs" c="#92400e" ta="center" style={{ maxWidth: '150px' }}>
            {data.title}
          </Text>
        )}
        
        {branches.length > 0 && (
          <Box mt={4}>
            <Text size="10px" c="dimmed" ta="center">
              {branches.length} {branches.length === 1 ? 'path' : 'paths'}
            </Text>
          </Box>
        )}
      </Stack>
      
      {branches.map((branch: any, index: number) => (
        <Handle
          key={`branch-${index}`}
          type="source"
          position={Position.Bottom}
          id={`branch-${index}`}
          style={{ 
            left: `${getHandlePosition(index, branches.length)}%`,
            background: '#f59e0b',
          }}
        />
      ))}
    </Box>
  );
}

export default memo(BranchNode);
